import React from 'react';
import './gameUi.css';
import {MaskedIcon} from '../coloredIcons/MaskedIcon/MaskedIcon';
import {joinClassNames} from './joinClassNames';

/**
 * Иконка, «выгравированная» в плите: одноцветный силуэт (MaskedIcon) с
 * бликом снизу и тенью сверху. Цвет по умолчанию — цвет текста плиты, поэтому
 * на эмали цвета игрока иконка сама становится темной или светлой
 * @param {string} src - рантайм-путь к одноцветной иконке (/img/icons/...)
 * @param {number} [size] - сторона в px
 * @param {string} [color] - явный цвет
 * @param {string} [alt]
 */
export function EngravedIcon({src, size = 24, color, alt, className, ...rest}) {
  return (
    <span
      className={joinClassNames('gui-engraved', className)}
      style={{'--gui-icon-size': `${size}px`, ...(color ? {'--gui-icon-color': color} : null)}}
      {...rest}
    >
      <MaskedIcon src={src} alt={alt}/>
    </span>
  );
}

export default EngravedIcon;
